import {HStack, Link as ChakraLink, Text, useDisclosure, useTheme} from '@chakra-ui/react'
import {faChevronRight, faCode} from '@fortawesome/pro-regular-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Model, Service, ServiceGroup, SkillDescription} from '../../dataModels/Service'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'
import Trans from 'next-translate/Trans'
import {track} from '../../utils/eventTracking/track'

interface Props {
  service: Service
  serviceGroup: ServiceGroup
}

const APIInfoModal = dynamic(() => import('../Modals/APIInfoModal'))

const APIOpenModalFooter = ({service, serviceGroup}: Props) => {
  const theme = useTheme()

  const {onOpen, isOpen, onClose} = useDisclosure()
  const {t} = useTranslation()

  return (
    <HStack m={0} p={0}>
      {isOpen && (
        <APIInfoModal
          isOpen={isOpen}
          onClose={onClose}
          service={service}
          serviceGroup={serviceGroup}
        />
      )}
      <Text color={theme.colors.text.light} textAlign={['center', null, 'start']}>
        <FontAwesomeIcon icon={faCode} />
        <Trans
          i18nKey={
            service instanceof Model
              ? 'model:open_mode_subscribe_encouragement_text'
              : 'skill:skill_API_information'
          }
          components={[
            <ChakraLink
              key='0'
              _hover={{opacity: 0.7}}
              fontWeight={theme.fontWeights.normal}
              variant='textLightPrimary'
              onClick={() => {
                onOpen()
                track(
                  `feature-click-${
                    service instanceof SkillDescription
                      ? service.skillName
                      : (service as Model).modelName
                  }-api-modal`
                )
              }}>
              {service instanceof Model
                ? t('model:open_mode_subscribe_encouragement_link')
                : t('skill:skill_API_link')}
              <FontAwesomeIcon icon={faChevronRight} size='sm' />
            </ChakraLink>,
          ]}
        />
      </Text>
    </HStack>
  )
}

export default APIOpenModalFooter
